<template>
  <div class="content line_height">
    <div v-html="data"></div>
  </div>
</template>

<script>
import http from '@/utils/axios'
export default {
  data() {
    return {
      data: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let url = '/mkc/giftCard/risk'
      http({
        url: url,
        method: 'get',
        parmes: {}
      }).then(res => {
        if (res.code == 200) {
          this.data = res.data.content
          this.$loading.hide();
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 0 30px 30px 30px;
}
</style>